import React from 'react'

function PlaceOrder() {
  return (
    <div>PlaceOrder</div>
  )
}

export default PlaceOrder